import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownTourContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownTourContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownTourContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownTourContracts/${id}`, request)
}

export {get, post, put, patch}
